import { useEffect, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { useLocalStorage } from 'hooks/localstorage';
import { useHotkeys } from 'react-hotkeys-hook';
import TimeDisplay from './time-display';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { stopwatchState, startedStopwatchState } from 'store/atoms';

import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';




export default function Display({ t = () => { }, is_last = false, lap_time, default_time, showall = true, is_started = false, fullscreenfn = null }) {
    const [started, setStarted] = useState(is_started);

    const [openedSettings, setOpenedSettings] = useState(false);
    const [toggleEco, setToggleEco] = useState(false);
    const [startTime, setStartTime] = useState(false);

    const [time, setTime] = useState(0);
    const [openedHotKeys, setOpenedHotKeys] = useState(false);
    const [lsstopwatch, setLsstopwatch] = useLocalStorage("stopwatch", { currenttime: null, history: [] });
    const [startedcnt, setStartedcnt] = useState(false);
    const [lscntdwnstart, setLscntdwnstart] = useLocalStorage("lscntdwnstart", 0);
    const [cntdwnstart, setCntdwnstart] = useState(0);
    const setStopwatch = useSetRecoilState(stopwatchState);
    const stopwatch = useRecoilValue(stopwatchState);
    const startedStopwatch = useRecoilValue(startedStopwatchState);
    const setStartedStopwatch = useSetRecoilState(startedStopwatchState);





    const interval = useRef(null);



    useEffect(() => {
        if (stopwatch.history.length === 0 && lsstopwatch && lsstopwatch.history.length > 0) {
            setStopwatch({ currenttime: lsstopwatch.currenttime, history: [...lsstopwatch.history] });
        }
    }, []);
    useEffect(() => {
        setStarted(is_started);
    }, [is_started]);

    /*useEffect(() => {
        if (lscntdwnstart) {
            setCntdwnstart(lscntdwnstart);
        }
    }, []);*/

    useHotkeys('tab', () => {
        start();
    });

    useHotkeys('l', () => {
        lap();

    });
    useHotkeys('r', () => {
        reset();
    });
    useHotkeys('-', () => {
        stop();
    });

    useEffect(() => {

        if (startTime > 0) {
            interval.current = setInterval(() => {
                setTime(() => Date.now() - startTime);
            }, 1);
        } else {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = undefined;
            }
        }
    }, [startTime]);





    const tickcntdwnstart = () => {
        setCntdwnstart((prev) => {
            return prev - 1;
        });
    }


    const start = () => {

        setStarted(true);
        setStartTime(stopwatch?.currenttime?.totalTimeMs ? Date.now() - stopwatch?.currenttime?.totalTimeMs : Date.now());
        setStartedStopwatch({ ...startedStopwatch, started: true });

        /* if (cntdwnstart > 0) {
             setStartedcnt(true);
         }
 
 
         setTimeout(() => {
             setStarted(true);
             setStartTime(Date.now());
             setStartedStopwatch({ ...startedStopwatch, started: true });
         }, cntdwnstart * 1000);*/
    };

    const padStart = (num) => {
        return num.toString().padStart(2, "0");
    };

    const formatMs = (milliseconds) => {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        // using the modulus operator gets the remainder if the time roles over
        // we don't do this for hours because we want them to rollover
        // seconds = 81 -> minutes = 1, seconds = 21.
        // 60 minutes in an hour, 60 seconds in a minute, 1000 milliseconds in a second.
        minutes = minutes % 60;
        seconds = seconds % 60;
        // divide the milliseconds by 10 to get the tenths of a second. 543 -> 54
        const ms = Math.floor((milliseconds % 1000));


        return {
            totalTimeMs: milliseconds,
            currentTimeMs: ms,
            currentTimeSec: seconds,
            currentTimeMin: minutes,
            currentTimeHr: hours
        }


    };


    const stop = () => {
        setStarted(false);
        setStartTime(false);
        if (lsstopwatch && lsstopwatch.history) {
            setLsstopwatch({
                currenttime: { ...(formatMs(time)) },
                history: [...lsstopwatch.history]
            });
            setStopwatch({
                currenttime: { ...(formatMs(time)) },
                history: [...stopwatch.history]
            });
        }

        setStartedStopwatch({ ...startedStopwatch, started: false });
    };


    const reset = () => {
        setLsstopwatch({ currenttime: null, history: [] });
        setStopwatch({ currenttime: null, history: [] });
    }



    const lap = () => {
        let need_2_push = {
            ...(formatMs(time)),
            timestamp: time,
            totaltime: { ...(formatMs(time)) },
            time_recorded: moment().format(),
            comment: ''
        };

        if (stopwatch && stopwatch.history) {
            const max_timestamp = stopwatch.history.length > 0 ? Math.max(...[...stopwatch.history.map(v => v.timestamp)]) : 0;
            need_2_push = {
                ...need_2_push,
                ...(formatMs(time - max_timestamp))
            }
            setStopwatch({
                currenttime: { ...(formatMs(time)) },
                history: [need_2_push, ...stopwatch.history]
            })

        }
        if (lsstopwatch && lsstopwatch.history) {
            setLsstopwatch({
                currenttime: { ...(formatMs(time)) },
                history: [need_2_push, ...stopwatch.history]
            })

        }

    }

    const openSettings = () => {
        setOpenedSettings(true);
    }
    const openHotKeys = () => {
        setOpenedHotKeys(true);
    }
    const handleToggleEco = () => {
        setToggleEco(!toggleEco);
    }

    const closeSettings = () => {
        setOpenedSettings(false);
    }
    const closeHotKeys = () => {
        setOpenedHotKeys(false);
    }
    const handleCntdwnstart = (e) => {
        setLscntdwnstart(e.target.value);
        setCntdwnstart(e.target.value);
    }



    return (
        <>

            <div className={is_last ? `` : 'm-bottom-24'}>
                <TimeDisplay is_eco={toggleEco} extraClass={is_last ? `gray-display` : ''} currenttime={!started ? formatMs(stopwatch?.currenttime?.totalTimeMs || 0) : formatMs(time)} />
                {showall && <div className="display-operations">
                    {!started && <div className="btn-div">
                        <Button variant="contained" onClick={start}>
                            {t('Start')}
                        </Button>
                    </div>}
                    {started && <div className="btn-div">
                        <Button variant="contained" onClick={stop}>
                            {t('Stop')}
                        </Button>
                    </div>}
                    {cntdwnstart > 0 && <div className="countdown-2-start">
                        {cntdwnstart}
                    </div>}
                    {started && <div className={"btn-div active-lap"}>
                        <Button variant="contained" onClick={started ? lap : () => { }}>
                            {t('Lap')}
                        </Button>
                    </div>}
                    {!started && <div className={"btn-div active-lap"}>
                        <Button variant="contained" onClick={!started ? reset : () => { }}>
                            {t('Reset')}
                        </Button>
                    </div>}
                </div>}
            </div>
            {
                showall && <div className="right-operations">
                    {/*<div className='circle-container'>
                        <div className="circle" title={t('key_countdown_to_start')} onClick={openSettings}>
                            {(<svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 16.6663C6.4529 16.6663 4.96917 16.0518 3.87521 14.9578C2.78125 13.8638 2.16667 12.3801 2.16667 10.833C2.16667 9.28591 2.78125 7.80218 3.87521 6.70822C4.96917 5.61426 6.4529 4.99967 8 4.99967C9.5471 4.99967 11.0308 5.61426 12.1248 6.70822C13.2188 7.80218 13.8333 9.28591 13.8333 10.833C13.8333 12.3801 13.2188 13.8638 12.1248 14.9578C11.0308 16.0518 9.5471 16.6663 8 16.6663ZM13.8583 6.15801L15.0417 4.97467C14.6667 4.54967 14.2917 4.16634 13.8667 3.79967L12.6833 4.99967C11.3917 3.94967 9.76667 3.33301 8 3.33301C6.01088 3.33301 4.10322 4.12318 2.6967 5.52971C1.29018 6.93623 0.5 8.84388 0.5 10.833C0.5 12.8221 1.29018 14.7298 2.6967 16.1363C4.10322 17.5428 6.01088 18.333 8 18.333C12.1667 18.333 15.5 14.9747 15.5 10.833C15.5 9.06634 14.8833 7.44134 13.8583 6.15801ZM7.16667 11.6663H8.83333V6.66634H7.16667M10.5 0.833008H5.5V2.49967H10.5V0.833008Z" fill="#444D67" />
                            </svg>
                            )}

                        </div>
                        <div className='title'>
                            {t('Countdown to start')}
                        </div>
                    </div>*/}
                    <div className='circle-container'>
                        <div className="circle" title={t('key_following_hot_keys')} onClick={openHotKeys}>
                            {(<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.33317 0.166504C1.89114 0.166504 1.46722 0.342099 1.15466 0.654659C0.842099 0.96722 0.666504 1.39114 0.666504 1.83317V10.1665C0.666504 10.6085 0.842099 11.0325 1.15466 11.345C1.46722 11.6576 1.89114 11.8332 2.33317 11.8332H15.6665C16.1085 11.8332 16.5325 11.6576 16.845 11.345C17.1576 11.0325 17.3332 10.6085 17.3332 10.1665V1.83317C17.3332 1.39114 17.1576 0.96722 16.845 0.654659C16.5325 0.342099 16.1085 0.166504 15.6665 0.166504H2.33317ZM2.33317 1.83317H15.6665V10.1665H2.33317V1.83317ZM3.1665 2.6665V4.33317H4.83317V2.6665H3.1665ZM5.6665 2.6665V4.33317H7.33317V2.6665H5.6665ZM8.1665 2.6665V4.33317H9.83317V2.6665H8.1665ZM10.6665 2.6665V4.33317H12.3332V2.6665H10.6665ZM13.1665 2.6665V4.33317H14.8332V2.6665H13.1665ZM3.1665 5.1665V6.83317H4.83317V5.1665H3.1665ZM5.6665 5.1665V6.83317H7.33317V5.1665H5.6665ZM8.1665 5.1665V6.83317H9.83317V5.1665H8.1665ZM10.6665 5.1665V6.83317H12.3332V5.1665H10.6665ZM13.1665 5.1665V6.83317H14.8332V5.1665H13.1665ZM5.6665 7.6665V9.33317H12.3332V7.6665H5.6665Z" fill="#444D67" />
                            </svg>

                            )}
                        </div>
                    </div>
                    <div className='circle-container'>
                        <div className={toggleEco ? "circle active-eco" : "circle"} title={t('key_eco_mode')} onClick={handleToggleEco}>
                            {(<svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.654785 7V0.557617H5.43164V1.64746H1.95557V3.07568H5.18994V4.16113H1.95557V5.91455H5.55469V7H0.654785ZM10.7798 4.63135L12.041 5.03125C11.8477 5.73438 11.5254 6.25732 11.0742 6.6001C10.626 6.93994 10.0562 7.10986 9.36475 7.10986C8.50928 7.10986 7.80615 6.81836 7.25537 6.23535C6.70459 5.64941 6.4292 4.84961 6.4292 3.83594C6.4292 2.76367 6.70605 1.93164 7.25977 1.33984C7.81348 0.745117 8.5415 0.447754 9.44385 0.447754C10.2319 0.447754 10.8721 0.680664 11.3643 1.14648C11.6572 1.42188 11.877 1.81738 12.0234 2.33301L10.7358 2.64062C10.6597 2.30664 10.5 2.04297 10.2568 1.84961C10.0166 1.65625 9.72363 1.55957 9.37793 1.55957C8.90039 1.55957 8.51221 1.73096 8.21338 2.07373C7.91748 2.4165 7.76953 2.97168 7.76953 3.73926C7.76953 4.55371 7.91602 5.13379 8.20898 5.47949C8.50195 5.8252 8.88281 5.99805 9.35156 5.99805C9.69727 5.99805 9.99463 5.88818 10.2437 5.66846C10.4927 5.44873 10.6714 5.10303 10.7798 4.63135ZM12.8979 3.81836C12.8979 3.16211 12.9961 2.61133 13.1924 2.16602C13.3389 1.83789 13.5381 1.54346 13.79 1.28271C14.0449 1.02197 14.3232 0.828613 14.625 0.702637C15.0264 0.532715 15.4893 0.447754 16.0137 0.447754C16.9629 0.447754 17.7217 0.742188 18.29 1.33105C18.8613 1.91992 19.147 2.73877 19.147 3.7876C19.147 4.82764 18.8643 5.64209 18.2988 6.23096C17.7334 6.81689 16.9775 7.10986 16.0312 7.10986C15.0732 7.10986 14.3115 6.81836 13.7461 6.23535C13.1807 5.64941 12.8979 4.84375 12.8979 3.81836ZM14.2383 3.77441C14.2383 4.50391 14.4067 5.05762 14.7437 5.43555C15.0806 5.81055 15.5083 5.99805 16.0269 5.99805C16.5454 5.99805 16.9702 5.81201 17.3013 5.43994C17.6353 5.06494 17.8022 4.50391 17.8022 3.75684C17.8022 3.01855 17.6396 2.46777 17.3145 2.10449C16.9922 1.74121 16.563 1.55957 16.0269 1.55957C15.4907 1.55957 15.0586 1.74414 14.7305 2.11328C14.4023 2.47949 14.2383 3.0332 14.2383 3.77441Z" fill="#444D67" />
                            </svg>
                            )}

                        </div>
                        <div className='title'>
                            {t('ECO mode')}
                        </div>
                    </div>
                    <div className='circle-container key_fullscreen'>
                        <div className="circle" title={t('key_fullscreen')} onClick={fullscreenfn && fullscreenfn.enter}>
                            {(<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.166504 0.166992H4.33317V1.83366H1.83317V4.33366H0.166504V0.166992ZM7.6665 0.166992H11.8332V4.33366H10.1665V1.83366H7.6665V0.166992ZM10.1665 7.66699H11.8332V11.8337H7.6665V10.167H10.1665V7.66699ZM4.33317 10.167V11.8337H0.166504V7.66699H1.83317V10.167H4.33317Z" fill="#444D67" />
                            </svg>

                            )}

                        </div>
                        <div className='title'>
                            {t('Fullscreen')}
                        </div>
                    </div>
                </div>
            }

            <Dialog className="trashDialog" open={openedSettings} onClose={closeSettings}>
                <DialogContent>

                    <div className="message-text">
                        <div className='settings-countdown'>
                            <div className='settings-countdown-title'>{t('key_countdoun_2_start')}</div>
                            <FormControl className='comment-input' variant="standard">
                                <div className='field'>
                                    <TextField
                                        type="number"
                                        className="text-input"
                                        value={cntdwnstart}
                                        //  onBlur={handleBlur}
                                        onChange={handleCntdwnstart}
                                    />
                                </div>
                            </FormControl>
                        </div>
                    </div>
                    <DialogActions>
                        <Button className="cancelButton" onClick={closeSettings}>{t('Cancel')}</Button>
                        <Button className="deleteButton" onClick={closeSettings}>{t('Save')}</Button>
                    </DialogActions>
                </DialogContent>

            </Dialog>
            <Dialog className="trashDialog" open={openedHotKeys} onClose={closeHotKeys}>
                <DialogContent>

                    <div className="message-text">
                        <div className="hot-key">
                            <div className="hot-key-title">{t('Start/Stop')}:</div>
                            <div className="hot-key-keys"><div className="key">Tab</div>&nbsp;and&nbsp;<div className="key">-</div></div>
                        </div>
                        <div className="hot-key">
                            <div className="hot-key-title">{t('Lap')} :</div>
                            <div className="hot-key-keys"><div className="key">L</div></div>
                        </div>
                        <div className="hot-key">
                            <div className="hot-key-title">{t('Resset')} :</div>
                            <div className="hot-key-keys"><div className="key">R</div></div>
                        </div>
                        <div className="hot-key">
                            <div className="hot-key-title">{t('Export results')}  :</div>
                            <div className="hot-key-keys"><div className="key">E</div></div>
                        </div>
                        <div className="hot-key">
                            <div className="hot-key-title">{t('Fullscreen')} :</div>
                            <div className="hot-key-keys"><div className="key">F</div></div>
                        </div>
                    </div>
                    <DialogActions>
                        <Button className="cancelButton" onClick={closeHotKeys}>{t('Cancel')}</Button>
                        <Button className="deleteButton" onClick={closeHotKeys}>{t('Ok')}</Button>
                    </DialogActions>
                </DialogContent>

            </Dialog>
        </>

    )
}



